import React from "react";
import arrowRight from "../../../../components/icon/assets/arrow-right.svg";
import closeLogo from "../../../../components/icon/assets/close.svg";
import { useSetting } from "./setting.hook";
import { SxProps, Theme } from "@mui/material";
import { useTranslation } from "react-i18next";
import FullListPopup from "../../../../components/full-list-popup/full-list-popup";
import styles from "./setting.module.css";
import { languageSelectionConfig } from "../../utils";
import { getItem, setItem } from "../../../../utils/local-storage";
import { useA2HS } from "../../../../utils/hooks/use-a2hs";
import { takeUIClickEvent } from "../../../../common/ga/ga";
import { TakeUIClickEventParameters } from "../../../../common/ga/types/ga-general-type";
import { isStandalone } from "../../../../utils/standalone";
import { IOSSwitch } from "../../../../components/switch/ios-switch";

type SettingProps = {};

export const docButton: SxProps<Theme> = {
  width: "100%",
  fontWeight: 600,
  fontSize: "16px",
  height: "48px",
};

export const SettingScreen = (props: SettingProps) => {
  const {
    isPopupOpen,
    clickSetting,
    clickLanguage,
    clickDisclaimer,
    clickPrivacy,
    clickLogout,
    clickClose,
    pushNotificationEnabled,
    togglePushNotification,
    toggling,
  } = useSetting();
  const { t, i18n } = useTranslation();
  const { triggerA2HSPrompt } = useA2HS();

  const handleEnableShortcut = () => {
    triggerA2HSPrompt(true); // Force trigger A2HS prompt
    const gaData: TakeUIClickEventParameters = {
      module: "Settings",
      feature: "A2HS",
      journey: "add_to_homescreen",
      stage: "trigger_prompt",
      screen_id: "SCR_STTNG",
      screen_name: "Settings-Screen",
      object_name: "Enable_Shortcut",
      object_type: "BUTTON",
    };
    takeUIClickEvent(gaData);
  };

  return (
    <div className={styles.container}>
      {/* Header section */}
      <div className={styles.header}>
        <span className={styles.title} onClick={clickSetting}>
          {t("Common.settings")}
        </span>
        <img src={closeLogo} alt="" className={styles.logoImg} onClick={clickClose}></img>
      </div>
      {/* List section */}
      <div>
        <div className={styles.line} onClick={clickLanguage}>
          <span className={styles.text}> {t("Common.language")}</span>
          <img src={arrowRight} alt="" className={styles.logoImg}></img>
        </div>
        {isStandalone() ? null : (
          <div className={styles.line} onClick={handleEnableShortcut}>
            <span className={styles.text}> {t("Common.enable_shortcut")}</span>
            <img src={arrowRight} alt="" className={styles.logoImg}></img>
          </div>
        )}
        <div className={styles.line}>
          <div className="flex-1">
            <span className={styles.text}> {t("Common.push_notification")}</span>
          </div>
          <IOSSwitch
            checked={pushNotificationEnabled}
            onChange={togglePushNotification}
            loading={toggling}
            disabled={toggling}
            color="primary"
          />
        </div>
        <div className={styles.line} onClick={clickDisclaimer}>
          <span className={styles.text}> {t("Common.disclaimer")}</span>
          <img src={arrowRight} alt="" className={styles.logoImg}></img>
        </div>
        <div className={styles.line} onClick={clickPrivacy}>
          <span className={styles.text}> {t("Common.privacy_notice")}</span>
          <img src={arrowRight} alt="" className={styles.logoImg}></img>
        </div>
      </div>
      {/* Bottom section */}
      <div className={styles.fixedBottom}>
        <button className={styles.logoutButton} onClick={clickLogout}>
          {t("Common.logout")}
        </button>
      </div>

      <FullListPopup
        title={t("Common.language")}
        isOpen={isPopupOpen}
        onClose={clickLanguage}
        selectData={{ value: getItem("i18nextLng") as string }}
        onChange={(data) => {
          if (data.value) {
            setItem("i18nextLng", data.value);
            i18n.changeLanguage(data.value);
          }
        }}
        data={languageSelectionConfig().availableLanguages.map((lang) => ({
          label: lang.languageFullName,
          value: lang.i18nLanguageCode,
        }))}
      />
    </div>
  );
};
